'use client';

import React from 'react';
import { RevshareTransaction } from '../types';
import Typography from '../../../../components/typography/Typography';

interface AmountCellProps {
  transaction: RevshareTransaction;
}

const AmountCell: React.FC<AmountCellProps> = ({ transaction }) => {
  const amount = parseFloat(transaction.amount - transaction.fee) || 0;

  return (
    <div className="flex items-center">
      <Typography variant="body2" className="!font-semibold !text-auth-ink">
        ${amount.toFixed(2)}
      </Typography>
    </div>
  );
};

export default AmountCell;
